export default "__VITE_ASSET__559b0167__"